import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Invoices from "./pages/Invoices";
import Financieel from "./pages/Financieel";
import Apartments from "./pages/Apartments";
import AdminDashboard from "./pages/AdminDashboard";
import OwnerDashboard from "./pages/OwnerDashboard";
import Safe from "./pages/Safe";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Navigate to="/login" replace />} />
                <Route path="/home" element={
                    <ProtectedRoute>
                        <Home />
                    </ProtectedRoute>
                } />
                <Route path="/apartments" element={
                    <ProtectedRoute allowedRoles={["admin", "staff"]}>
                        <Apartments />
                    </ProtectedRoute>
                } />
                <Route path="/invoices" element={
                    <ProtectedRoute allowedRoles={["admin", "staff"]}>
                        <Invoices />
                    </ProtectedRoute>
                } />
                <Route path="/financieel" element={
                    <ProtectedRoute allowedRoles={["admin", "staff"]}>
                        <Financieel />
                    </ProtectedRoute>
                } />
                <Route path="/financial" element={
                    <ProtectedRoute allowedRoles={["admin", "staff"]}>
                        <Financieel />
                    </ProtectedRoute>
                } />
                <Route path="/safe" element={
                    <ProtectedRoute allowedRoles={["admin", "staff"]}>
                        <Safe />
                    </ProtectedRoute>
                } />
                <Route path="/admin" element={
                    <ProtectedRoute requiredRole="admin">
                        <AdminDashboard />
                    </ProtectedRoute>
                } />
                <Route path="/owner" element={
                    <ProtectedRoute requiredRole="owner">
                        <OwnerDashboard />
                    </ProtectedRoute>
                } />
            </Routes>
        </Router>
    );
}
